import { KardexPeriodoInput } from '../../../base/interfaces/index'
/**
 * Componemos el input a valores que acepta el servicio
 * @param input
 */
export const kardexPeriodoIniciarComposeService = (
  input: KardexPeriodoInput,
): KardexPeriodoInput => {
  return {
    descripcion: input.descripcion,
    codigoDocumentoSector: input.codigoDocumentoSector,
  }
}
